import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Dialog, ListItemButton, ListItemIcon, ListItemText, Link, Slide, Toolbar, Box, } from "@mui/material";
import TermsAndConditions from "app/other/TermsAndConditions";
import { clientConfigFn } from "clientConfig";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { NavbarIconButton } from "./NavbarIconButton";
import { NavbarText } from "./NavbarText";
import { useSafeArea } from "./useSafeArea";
const Transition = React.forwardRef(function Transition(props, ref) {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
export const TermsAndConditionsItem = () => {
    const { linkToTermsAndConditions } = clientConfigFn();
    const { insetTop } = useSafeArea();
    const [openTerms, setOpenTerms] = React.useState(false);
    const handleClickOpenTerms = () => {
        setOpenTerms(true);
    };
    const handleCloseTerms = () => {
        setOpenTerms(false);
    };
    if (linkToTermsAndConditions !== "") {
        return (_jsx("div", { className: "button-container", children: _jsx(Link, { href: linkToTermsAndConditions, target: "_blank", rel: "noopener norefferer", component: "a", children: _jsxs(ListItemButton, { title: "Terms and Conditions", id: "openTermsAndConditions", children: [_jsx(ListItemIcon, { children: _jsx(GavelOutlinedIcon, {}) }), _jsx(ListItemText, { primary: "Terms and Conditions" })] }) }) }));
    }
    return (_jsxs("div", { className: "button-container", children: [_jsxs(ListItemButton, { onClick: handleClickOpenTerms, title: "Terms and Conditions", id: "openTermsAndConditions", children: [_jsx(ListItemIcon, { children: _jsx(GavelOutlinedIcon, {}) }), _jsx(ListItemText, { primary: "Terms and Conditions" })] }), _jsxs(Dialog, { className: "terms-conditions-dialog", fullScreen: true, open: openTerms, onClose: handleCloseTerms, TransitionComponent: Transition, sx: { paddingTop: `${insetTop}px` }, children: [_jsxs(AppBar, { className: "appbar-legal", sx: {
                            position: "fixed",
                        }, children: [_jsx(Box, { sx: { height: insetTop } }), _jsxs(Toolbar, { children: [_jsx(NavbarText, { children: "Terms and Conditions" }), _jsx(NavbarIconButton, { edge: "end", color: "inherit", onClick: handleCloseTerms, "aria-label": "close", id: "closeTermsAndConditions", children: _jsx(CloseIcon, {}) })] })] }), _jsx(TermsAndConditions, {})] })] }));
};
